webpackJsonp([1],{

/***/ "+gtd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAwlIRrZ1AAAALxJREFUWMPtV8ENxCAMi6Mbg/0nYw/3FQlVAUrvCEhH3m3tOGlkg6SMFIDmCyQx8r3PKGjO+fGzT8igpwAA9kBrlVLqkqgSsE7egpckWmq4BL7pelQNjQA3Jb0F1gjwFgmVxaVR3ddU0Ehw75YsG4GpsHwHICKh8t9vwz5/wSFwCPwvAZIw0xB9A0jijEDNr0WOobRnWlroCBJ3b7jXDsxWwXPG6kWrGSRqtnzPYLJFNHurSDm+n4TT2fH8AoeelHOgZzQTAAAAAElFTkSuQmCC"

/***/ }),

/***/ "0nY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Random = function () {
  function Random(seed) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Random);

    if (seed == null) {
      this.y = Math.random() * 2147483647;
    } else {
      this.y = seed;
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Random, [{
    key: "setSeed",
    value: function setSeed(seed) {
      this.y = seed;
    }
  }, {
    key: "next",
    value: function next() {
      this.y = this.y ^ this.y << 13;
      this.y = this.y ^ this.y >> 17;
      this.y = this.y ^ this.y << 15;
      return this.y >>> 0;
    }
  }, {
    key: "nextInt",
    value: function nextInt(max) {
      // 0 ~ max未満のランダムな整数を返す
      var r = Math.abs(this.next());
      return r % max;
    }
  }]);

  return Random;
}();

/* harmony default export */ __webpack_exports__["a"] = (Random);

/***/ }),

/***/ "33aG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoVDjMSMffk+QAAAMxJREFUWMPVl8sOhDAIRaWZ/274clzVMGgtTC40w8qYJufIQ5FE5NgZ7dgcnwoIEV1pFhEqExjg3vvXPS1BWT1ARKLBOpj5ykSrhpc0oYgQM9cL2GbzSDR02lcSuv4wAV3zNwkLh0zBrOEszI4fRGDV7U9PDOsBz6jZcsAEvHOekgEkPCyAhocEMuBugSy4SyATvhTIhr8KVMCnAlXwR4FK+E2gGv7TmxAJDwug4SGBDLhbIAt+W0hm32672US243F+XMNXsr//Od0ucALKWNC05Up3vwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "5+Oq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Puyo__ = __webpack_require__("5oUX");




function dropPuyo(field, x, kind) {
  var pos = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(x, 13);
  if (field.isBrank(pos)) {
    field.set(pos, kind);
    field.fall();
  }
}

function setOpsToField(field, x, dir, puyoPair) {
  var ax = x;
  var sx = dir === 1 ? x + 1 : dir === 3 ? x - 1 : x;
  if (dir === 2) {
    dropPuyo(field, sx, puyoPair.sub);
    dropPuyo(field, ax, puyoPair.axis);
  } else {
    dropPuyo(field, ax, puyoPair.axis);
    dropPuyo(field, sx, puyoPair.sub);
  }
}

function calcScore(num, color, connections, chain) {
  var A = [0, 8, 16, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 480, 512];
  var B = [0, 3, 6, 12, 24];
  var C = [0, 2, 3, 4, 5, 6, 7, 10];
  var base = num * 10;
  var rate = A[chain - 1];
  if (rate === undefined) rate = 512;
  rate += B[color - 1];
  for (var i = 0; i < connections.length; i++) {
    var n = connections[i];
    if (n > 11) rate += 10;else rate += C[n - 4];
  }
  if (rate === 0) rate = 1;
  return base * rate;
}

function newPos(x, y) {
  return new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(x, y);
}

var Chart = function () {
  function Chart() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Chart);

    this.chart = [];
    this.editedFields = [];
    this._size = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Chart, [{
    key: '_updateSize',
    value: function _updateSize(turn) {
      if (turn + 1 > this._size) this._size = turn + 1;
    }
  }, {
    key: 'set',
    value: function set(turn, x, dir) {
      if (turn > 999) return;
      this.chart[turn] = {
        x: x,
        dir: dir
      };
      this._updateSize(turn);
    }
  }, {
    key: 'setEditedField',
    value: function setEditedField(turn, field) {
      if (turn > 999) return;
      if (field != null && field.copy != null) {
        this.editedFields[turn] = field.copy();
      } else {
        this.editedFields[turn] = null;
      }
      this._updateSize(turn);
    }
  }, {
    key: 'get',
    value: function get(turn) {
      if (turn >= this._size) return {};
      return this.chart[turn];
    }
  }, {
    key: 'getEditedField',
    value: function getEditedField(turn) {
      if (turn >= this._size) return {};
      return this.editedFields[turn];
    }
  }, {
    key: 'size',
    value: function size() {
      return this._size;
    }
  }, {
    key: 'normalize',
    value: function normalize(next) {
      var field = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Field();
      for (var i = 0; i < this.size(); i++) {
        // 「ぷよ図編集」を処理
        var ef = this.getEditedField(i);
        if (ef != null) {
          if (ef.equal(field)) {
            this.editedFields[i] = null;
          } else {
            field = ef.copy();
          }
        }
        // 「手順」を処理
        var ch = this.get(i);
        setOpsToField(field, ch.x, ch.dir, next.get(i));
        if (!field.canFire()) continue;
        for (var _i = 1; _i < 20; _i++) {
          field.stepFire();
          field.fall();
          if (!field.canFire()) break;
        }
      }
    }
  }]);

  return Chart;
}();

var Game = function () {
  function Game() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Game);

    this.field = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Field();
    this.next = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Next();
    this.orgNext = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Next(this.next._seed);
    this.ops = {
      pos: new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(),
      dir: 0,
      available: false
    };
    this.turn = 0;
    this.chart = new Chart();
    this.score = 0;
    this.sumScore = 0;
    this.chain = 0;
    this.moveTurn(0);
    this.statisticsMaxChain = 0;
    this.statisticsMaxScore = 0;
    this.statisticsMaxConcurrent = 0;
    this.statisticsAllClear = 0;
    this.statisticsCount = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Game, [{
    key: 'axisPos',
    value: function axisPos() {
      return this.ops.pos;
    }
  }, {
    key: 'subPos',
    value: function subPos() {
      var axisPos = this.ops.pos;
      switch (this.ops.dir) {
        case 0:
          return new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(axisPos.x, axisPos.y + 1);
        case 1:
          return new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(axisPos.x + 1, axisPos.y);
        case 2:
          return new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(axisPos.x, axisPos.y - 1);
        case 3:
          return new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(axisPos.x - 1, axisPos.y);
      }
      return new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(); // error
    }
  }, {
    key: 'moveLeft',
    value: function moveLeft() {
      if (!this.ops.available) return;
      var ap = this.axisPos();
      var sp = this.subPos();
      if (this.field.isBrank(newPos(ap.x - 1, ap.y)) && this.field.isBrank(newPos(sp.x - 1, sp.y))) {
        this.ops.pos.x--;
      }
    }
  }, {
    key: 'moveRight',
    value: function moveRight() {
      if (!this.ops.available) return;
      var ap = this.axisPos();
      var sp = this.subPos();
      if (this.field.isBrank(newPos(ap.x + 1, ap.y)) && this.field.isBrank(newPos(sp.x + 1, sp.y))) {
        this.ops.pos.x++;
      }
    }
  }, {
    key: 'rotateLeft',
    value: function rotateLeft() {
      if (!this.ops.available) return false;
      var ap = this.axisPos();
      var apl = newPos(ap.x - 1, ap.y);
      var apr = newPos(ap.x + 1, ap.y);
      var apd = newPos(ap.x, ap.y - 1);
      switch (this.ops.dir) {
        case 0:
          if (!this.field.isBrank(apl)) {
            if (!this.field.isBrank(apr)) return false;
            this.ops.pos.x++;
          }
          break;
        case 1:
          break;
        case 2:
          if (!this.field.isBrank(apr)) {
            if (!this.field.isBrank(apl)) return false;
            this.ops.pos.x--;
          }
          break;
        case 3:
          if (!this.field.isBrank(apd)) {
            if (this.ops.pos.y >= this.field.Height()) return false;
            this.ops.pos.y++;
          }
          break;
      }
      this.ops.dir = (this.ops.dir + 3) % 4;
      return true;
    }
  }, {
    key: 'rotateRight',
    value: function rotateRight() {
      if (!this.ops.available) return false;
      var ap = this.axisPos();
      var apl = newPos(ap.x - 1, ap.y);
      var apr = newPos(ap.x + 1, ap.y);
      var apd = newPos(ap.x, ap.y - 1);
      switch (this.ops.dir) {
        case 0:
          if (!this.field.isBrank(apr)) {
            if (!this.field.isBrank(apl)) return false;
            this.ops.pos.x--;
          }
          break;
        case 1:
          if (!this.field.isBrank(apd)) {
            if (this.ops.pos.y >= this.field.Height()) return false;
            this.ops.pos.y++;
          }
          break;
        case 2:
          if (!this.field.isBrank(apl)) {
            if (!this.field.isBrank(apr)) return false;
            this.ops.pos.x++;
          }
          break;
        case 3:
          break;
      }
      this.ops.dir = (this.ops.dir + 1) % 4;
      return true;
    }
  }, {
    key: 'rotateLeftQuick',
    value: function rotateLeftQuick() {
      if (!this.ops.available) return false;
      if (this.ops.dir === 1 || this.ops.dir === 3) return false;
      var ap = this.axisPos();
      var apd = newPos(ap.x, ap.y - 1);
      var apl = newPos(ap.x - 1, ap.y);
      var apr = newPos(ap.x + 1, ap.y);
      if (this.ops.dir === 0) {
        if (!this.field.isBrank(apd)) {
          this.ops.pos.y++;
        } else {
          if (ap.x === 3 && ap.y === 12 && !this.field.isBrank(apl) && !this.field.isBrank(apr)) this.ops.pos.y++;
        }
      }
      this.ops.dir = (this.ops.dir + 2) % 4;
    }
  }, {
    key: 'rotateRightQuick',
    value: function rotateRightQuick() {
      return this.rotateLeftQuick();
    }
  }, {
    key: 'setDown',
    value: function setDown() {
      if (!this.ops.available) return;
      var ap = this.axisPos();
      var sp = this.subPos();
      if (!this.field.isBrank(ap) || !this.field.isBrank(sp)) {
        console.log('無理置き');
        return;
      }
      this.ops.available = false;
      // 設置
      // this.field.set(ap, this.next.get(this.turn).axis)
      // this.field.set(sp, this.next.get(this.turn).sub)
      // this.field.fall()
      setOpsToField(this.field, this.ops.pos.x, this.ops.dir, this.next.get(this.turn));
      // 履歴をセット
      this.chart.set(this.turn, this.ops.pos.x, this.ops.dir);
      // 発火可能なら発火処理
      if (this.field.canFire()) {
        this.chain = 0;
        this.score = 0;
        return;
      }
      this.chart.set(this.turn + 1, null, null);
      this.chart.setEditedField(this.turn + 1, null);
      this.moveTurn(this.turn + 1);
      return;
    }
  }, {
    key: 'moveTurn',
    value: function moveTurn(turnNum, opsSetFlag) {
      // console.log('moveTurn', turnNum, opsSetFlag)
      if (turnNum < 0) return;
      // Game初期化
      this.chain = 0;
      this.score = 0;
      this.sumScore = 0;
      this.statisticsMaxChain = 0;
      this.statisticsMaxConcurrent = 0;
      this.statisticsMaxScore = 0;
      this.statisticsAllClear = 0;
      this.statisticsCount = 0;
      // history から field を再現
      this.field = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Field();
      for (var i = 0; i < this.chart.size(); i++) {
        // 「ぷよ図編集」を処理
        var ef = this.chart.getEditedField(i);
        if (ef != null) {
          this.field = ef.copy();
        }
        if (i >= turnNum) break;
        // 「手順」を処理
        var _ch = this.chart.get(i);
        setOpsToField(this.field, _ch.x, _ch.dir, this.next.get(i));
        if (!this.field.canFire()) continue;
        this.score = 0;
        var ii = void 0;
        var count = 0;
        for (ii = 1; ii < 20; ii++) {
          var info = this.field.stepFire();
          var score = calcScore(info.num, info.color, info.connections, ii);
          this.chain = ii;
          this.score += score;
          this.sumScore += score;
          count += info.num;
          if (this.statisticsMaxConcurrent <= info.num) this.statisticsMaxConcurrent = info.num;
          this.field.fall();
          if (!this.field.canFire()) break;
        }
        if (this.field.isAllClear()) this.statisticsAllClear++;
        if (this.statisticsMaxChain <= ii) this.statisticsMaxChain = ii;
        if (this.statisticsMaxScore <= this.score) this.statisticsMaxScore = this.score;
        this.statisticsCount = count;
      }
      // 移動後の履歴状態に応じて処理
      var ch = this.chart.get(turnNum);
      if (ch == null || ch.x == null || ch.dir == null) {
        // case: 履歴が存在しないか不完全
        this.chart.set(turnNum, null, null);
        this.ops.pos = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(3, 12);
        this.ops.dir = 0;
      } else {
        // case: 履歴が存在
        if (opsSetFlag === true) {
          this.ops.pos = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(ch.x, 12);
          this.ops.dir = ch.dir;
          if (!this.field.isBrank(this.axisPos()) || !this.field.isBrank(this.subPos())) {
            this.ops.pos.y++;
          }
        } else {
          this.ops.pos = new __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Pos(3, 12);
          this.ops.dir = 0;
        }
      }
      this.turn = turnNum;
      this.ops.available = true;
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      if (this.field.canFall()) {
        this.field.fall();
        if (this.field.canFire()) return;
        this.ops.available = true;
        this.chart.set(this.turn + 1, null, null);
        this.chart.setEditedField(this.turn + 1, null);
        this.moveTurn(this.turn + 1);
        return;
      }
      if (this.field.canFire()) {
        var info = this.field.stepFire();
        this.chain++;
        var score = calcScore(info.num, info.color, info.connections, this.chain);
        this.score += score;
        this.sumScore += score;
        // step
        if (this.field.canFall()) return;
        this.ops.available = true;
        this.chart.set(this.turn + 1, null, null);
        this.chart.setEditedField(this.turn + 1, null);
        this.moveTurn(this.turn + 1);
        return;
      }
    }
  }, {
    key: 'existNextStep',
    value: function existNextStep() {
      return this.field.canFall() || this.field.canFire();
    }
  }, {
    key: 'setNextSeed',
    value: function setNextSeed(seed) {
      this.next.init(seed);
      this.orgNext.init(seed);
    }
  }, {
    key: 'setNextMode',
    value: function setNextMode(mode) {
      // this.next.init(this.next._seed, mode)
    }
  }, {
    key: 'editField',
    value: function editField(x, y, kind) {
      if (kind === __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Kind.PEKE) kind = __WEBPACK_IMPORTED_MODULE_2__Puyo__["a" /* default */].Kind.BRANK;
      this.field.set(newPos(x, y), kind);
    }
  }, {
    key: 'saveField',
    value: function saveField() {
      this.field.fall();
      this.chart.setEditedField(this.turn, this.field);
      this.chart.normalize(this.next);
    }
  }, {
    key: 'editNext',
    value: function editNext(turn, kind, isAxis) {
      this.next.edit(turn, kind, isAxis);
    }
  }]);

  return Game;
}();

/* harmony default export */ __webpack_exports__["a"] = (Game);

/***/ }),

/***/ "5oUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Random__ = __webpack_require__("0nY9");





// 定数
var Kind = { // ぷよの種類
  BRANK: 0,
  RED: 1,
  GREEN: 2,
  BLUE: 3,
  YELLOW: 4,
  PURPLE: 5,
  IRON: 6,
  OJAMA: 7,
  WALL: 8,
  PEKE: 9

  // 補助関数
};function isNull(obj) {
  return obj == null;
}

// クラス定義

var PuyoPair = function PuyoPair(axis, sub) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PuyoPair);

  this.axis = isNull(axis) ? Kind.BRANK : axis;
  this.sub = isNull(sub) ? Kind.BRANK : sub;
};

var Next = function () {
  function Next(seed, mode) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Next);

    this.init(seed, mode);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Next, [{
    key: 'init',
    value: function init(seed, mode) {
      // console.log('next init')
      if (mode == null) mode = 'random';
      this._mode = mode;
      if (seed == null) {
        var r = new __WEBPACK_IMPORTED_MODULE_3__Random__["a" /* default */]();
        seed = r.nextInt(64 * 64 * 64 * 64);
      }
      this._seed = seed;
      this._random = new __WEBPACK_IMPORTED_MODULE_3__Random__["a" /* default */](this._seed);
      this._size = 1000;
      this._puyos = [];
      // console.log(this._seed, this._mode)
      for (var i = 0; i < this._size; i++) {
        this._puyos.push(new PuyoPair(this._nextKind(), this._nextKind()));
      }
    }
  }, {
    key: 'size',
    value: function size() {
      return this._size;
    }
  }, {
    key: 'get',
    value: function get(num) {
      return this._puyos[num % 1024];
    }
  }, {
    key: '_nextKind',
    value: function _nextKind() {
      switch (this._random.nextInt(4)) {
        case 0:
          return Kind.RED;
        case 1:
          return Kind.GREEN;
        case 2:
          return Kind.BLUE;
        case 3:
          return Kind.YELLOW;
      }
      return Kind.BRANK;
    }
  }, {
    key: 'seed',
    value: function seed() {
      return this._seed;
    }
  }, {
    key: 'edit',
    value: function edit(turn, kind, isAxis) {
      if (turn >= this._size || turn < 0) return;
      if (isAxis) {
        this._puyos[turn].axis = kind;
      } else {
        this._puyos[turn].sub = kind;
      }
    }
  }]);

  return Next;
}();

var Pos = function Pos(x, y) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pos);

  this.x = isNaN(x) ? 0 : x;
  this.y = isNaN(y) ? 0 : y;
};

var Field = function () {
  function Field() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Field);

    this.height = 13;
    this.width = 6;
    this._field = [];
    for (var y = 0; y < this.height + 1; y++) {
      var line = [];
      for (var x = 0; x < this.width; x++) {
        line.push(Kind.BRANK);
      }
      this._field.push(line);
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Field, [{
    key: 'isBrank',
    value: function isBrank(pos) {
      return this.get(pos) === Kind.BRANK;
    }
  }, {
    key: 'get',
    value: function get(pos) {
      if (pos.y < 1 || pos.x < 1 || pos.x > this.width) {
        return Kind.WALL;
      }
      if (pos.y > this.height) {
        return Kind.BRANK;
      }
      return this._field[pos.y - 1][pos.x - 1];
    }
  }, {
    key: 'set',
    value: function set(pos, kind) {
      if (pos.y < 1 || pos.y > this.height + 1 || pos.x < 1 || pos.x > this.width) {
        return;
      }
      this._field[pos.y - 1][pos.x - 1] = kind;
    }
  }, {
    key: 'fall',
    value: function fall() {
      var flag = false; // 落下が発生したかどうか
      for (var x = 1; x <= this.width; x++) {
        var t = 1;
        for (var y = 1; y <= this.height; y++) {
          var p = this.get(new Pos(x, y));
          if (p === Kind.BRANK) continue;
          if (p === Kind.WALL) {
            t = y + 1;
            continue;
          }
          this.set(new Pos(x, y), this.get(new Pos(x, t)));
          this.set(new Pos(x, t), p);
          if (t !== y) flag = true;
          t++;
        }
      }
      for (var _x = 1; _x <= this.width; _x++) {
        this.set(new Pos(_x, 14), Kind.BRANK);
      }return flag;
    }
  }, {
    key: 'canFall',
    value: function canFall() {
      for (var x = 1; x <= this.width; x++) {
        for (var y = 2; y <= this.height; y++) {
          if (this.isBrank(new Pos(x, y - 1)) && !this.isBrank(new Pos(x, y)) && this.get(new Pos(x, y)) !== Kind.WALL) return true;
        }
      }
      return false;
    }
  }, {
    key: '_countConnection',
    value: function _countConnection(pos, kind, flags) {
      if (this.get(pos) === Kind.IRON) return 0;
      if (this.get(pos) === Kind.PEKE) return 0;
      if (this.get(pos) === Kind.WALL) return 0;
      if (this.get(pos) === Kind.BRANK) return 0;
      if (this.get(pos) === Kind.OJAMA) return 0;
      if (this.get(pos) !== kind) return 0;
      if (flags.get(pos) !== Kind.BRANK) return 0;
      if (pos.y >= 13) return 0;
      flags.set(pos, kind);
      return this._countConnection(new Pos(pos.x, pos.y + 1), kind, flags) + this._countConnection(new Pos(pos.x + 1, pos.y), kind, flags) + this._countConnection(new Pos(pos.x, pos.y - 1), kind, flags) + this._countConnection(new Pos(pos.x - 1, pos.y), kind, flags) + 1;
    }
  }, {
    key: 'countConnection',
    value: function countConnection(pos) {
      return this._countConnection(pos, this.get(pos), new Field());
    }
  }, {
    key: '_deleteConnection',
    value: function _deleteConnection(pos, kind) {
      if (this.get(pos) === Kind.BRANK) return 0;
      if (this.get(pos) === Kind.OJAMA) {
        this.set(pos, Kind.BRANK);
        return 0;
      }
      if (this.get(pos) !== kind) return 0;
      if (pos.y >= 13) return 0;
      this.set(pos, Kind.BRANK);
      return this._deleteConnection(new Pos(pos.x, pos.y + 1), kind) + this._deleteConnection(new Pos(pos.x + 1, pos.y), kind) + this._deleteConnection(new Pos(pos.x, pos.y - 1), kind) + this._deleteConnection(new Pos(pos.x - 1, pos.y), kind) + 1;
    }
  }, {
    key: 'deleteConnection',
    value: function deleteConnection(pos) {
      return this._deleteConnection(pos, this.get(pos));
    }
  }, {
    key: 'canFire',
    value: function canFire() {
      var flags = new Field();
      for (var y = 1; y < this.height; y++) {
        for (var x = 1; x <= this.width; x++) {
          var pos = new Pos(x, y);
          if (this._countConnection(pos, this.get(pos), flags) >= 4) return true;
        }
      }
      return false;
    }
  }, {
    key: 'stepFire',
    value: function stepFire() {
      var Step = function Step() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Step);

        this.num = 0; // 消えたぷよの数
        this.connections = []; // 連結数
        this.color = 0; // 色数
      };

      var step = new Step();
      var flags = new Field();
      var colorFlags = {};
      for (var y = 1; y < this.height; y++) {
        for (var x = 1; x <= this.width; x++) {
          var pos = new Pos(x, y);
          var kind = this.get(pos);
          var n = this._countConnection(pos, kind, flags);
          if (n >= 4) {
            this.deleteConnection(pos);
            step.num += n;
            step.connections.push(n);
            colorFlags[kind] = true;
          }
        }
      }
      step.color = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(colorFlags).length;
      return step;
    }
  }, {
    key: 'Height',
    value: function Height() {
      return this.height;
    }
  }, {
    key: 'Width',
    value: function Width() {
      return this.width;
    }
  }, {
    key: 'copy',
    value: function copy() {
      var fd = new Field();
      for (var y = 1; y <= this.height; y++) {
        for (var x = 1; x <= this.width; x++) {
          var pos = new Pos(x, y);
          fd.set(pos, this.get(pos));
        }
      }
      return fd;
    }
  }, {
    key: 'equal',
    value: function equal(field) {
      for (var y = 1; y <= this.height; y++) {
        for (var x = 1; x <= this.width; x++) {
          var pos = new Pos(x, y);
          if (this.get(pos) !== field.get(pos)) return false;
        }
      }
      return true;
    }
  }, {
    key: 'isAllClear',
    value: function isAllClear() {
      for (var y = 1; y <= this.height; y++) {
        for (var x = 1; x <= this.width; x++) {
          var pos = new Pos(x, y);
          if (this.get(pos) !== Kind.BRANK) return false;
        }
      }
      return true;
    }
  }]);

  return Field;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  Kind: Kind,
  Pos: Pos,
  Next: Next,
  Field: Field
});

/***/ }),

/***/ "8h30":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHABQpqrcNpgAAAMhJREFUWMPtl8ENgCAMRW13cA496GYyRUfjonM4BJ5ICCkgKoVEOKv/8VubXzDGDDlHrSr6AmmCnO/BHQBXdBrn6LPHuWfBJAHUqkxKNAaTgggC2Fs/FfcdCYGwAG9unesGSohbJ7kGRgnxGAQOlQ9K3T7kAkqKc7OkWgmsC9V7ALZlE7Xfnw3t/AUdoAP8F4A0gRujJGcAaYJeArR5TbIMbjxDN0JLQPjZsK0eKO0Cl4yRW61KQIRieZuLSROr2VNHPl9OS6/nF5anmhNSPxH1AAAAAElFTkSuQmCC"

/***/ }),

/***/ "9vzG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A9wT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAZiS0dEAP8A/wD/oL2nkwAAAEpJREFUWIXtlDEOACAIxNCPE16OM8bBBW+wHVmuQ4MZ/M443PLl5i6Q7t66HhFld7auXYCAPEKQI2+AR4SAPEKQI2+AR4SAPEKABbGlEhzdisz7AAAAAElFTkSuQmCC"

/***/ }),

/***/ "AtdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"left_content"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"statisticsArea"},[_c('div',[_vm._v("統計")]),_vm._v(" "),_c('div',[_vm._v("最大連鎖："+_vm._s(_vm.state.statisticsMaxChain)+"連鎖")]),_vm._v(" "),_c('div',[_vm._v("最大同時消し："+_vm._s(_vm.state.statisticsMaxConcurrent)+"個")]),_vm._v(" "),_c('div',[_vm._v("最大得点："+_vm._s(_vm.state.statisticsMaxScore)+"点")]),_vm._v(" "),_c('div',[_vm._v("合計消去ぷよ数:"+_vm._s(_vm.state.statisticsCount)+"個")]),_vm._v(" "),_c('div',[_vm._v("全消し回数："+_vm._s(_vm.state.statisticsAllClear)+"回")])]),_vm._v(" "),_c('div',{staticClass:"nazoConfigArea"},[_c('div',[_vm._v("なぞぷよ条件")]),_vm._v(" "),_c('div',[_vm._v("\n        Type:\n        "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.nazoMode),expression:"state.nazoMode"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.state.nazoMode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("未設定")]),_vm._v(" "),_c('option',[_vm._v("全消し")]),_vm._v(" "),_c('option',[_vm._v("連鎖")]),_vm._v(" "),_c('option',[_vm._v("同時消し")]),_vm._v(" "),_c('option',[_vm._v("個数")])])]),_vm._v(" "),(_vm.state.nazoMode!=='未設定')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.nazoTurn),expression:"state.nazoTurn"}],staticStyle:{"width":"30px"},attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.state.nazoTurn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state.nazoTurn=$event.target.value}}}),_vm._v("手以内\n      ")]):_vm._e(),_vm._v(" "),(_vm.state.nazoMode==='全消し')?_c('div',[_vm._v("全消しすべし")]):_vm._e(),_vm._v(" "),(_vm.state.nazoMode==='連鎖')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.nazoChain),expression:"state.nazoChain"}],staticStyle:{"width":"30px"},attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.state.nazoChain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state.nazoChain=$event.target.value}}}),_vm._v("連鎖すべし")]):_vm._e(),_vm._v(" "),(_vm.state.nazoMode==='同時消し')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.nazoConcurrent),expression:"state.nazoConcurrent"}],staticStyle:{"width":"30px"},attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.state.nazoConcurrent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state.nazoConcurrent=$event.target.value}}}),_vm._v("個同時消しすべし")]):_vm._e(),_vm._v(" "),(_vm.state.nazoMode==='個数')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.nazoCount),expression:"state.nazoCount"}],staticStyle:{"width":"30px"},attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.state.nazoCount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state.nazoCount=$event.target.value}}}),_vm._v("個消すべし")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"main_content"}},[_c('div',{attrs:{"id":"top"}},[(_vm.state.isLoginWait)?_c('div',{attrs:{"id":"login-wait"},on:{"touchstart":_vm.loginClick,"mousedown":_vm.loginClick}},[_vm._v("確認中...")]):_vm._e(),_vm._v(" "),(!_vm.state.isLogin && !_vm.state.isLoginWait)?_c('div',{attrs:{"id":"login"},on:{"touchstart":_vm.loginClick,"mousedown":_vm.loginClick}},[_vm._v("ログイン"),_c('br'),_vm._v("していません")]):_vm._e(),_vm._v(" "),(_vm.state.isLogin && !_vm.state.isLoginWait)?_c('div',{attrs:{"id":"logout"},on:{"touchstart":_vm.loginClick,"mousedown":_vm.loginClick}},[_vm._v(_vm._s(_vm.state.userName))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"loginTriangle",on:{"touchstart":_vm.loginClick,"mousedown":_vm.loginClick}}),_vm._v(" "),_c('div',{attrs:{"id":"status"}},[_vm._v(_vm._s(_vm.state.statusStr))]),_vm._v(" "),_c('div',{style:(_vm.state.nazoClear?'color:#ff0000':''),attrs:{"id":"nazoStatus"}},[_vm._v(_vm._s(_vm.nazoStatusStr))]),_vm._v(" "),_c('img',{class:{editIconActive: _vm.state.editView},attrs:{"id":"editIcon","src":__webpack_require__("33aG")},on:{"touchstart":_vm.pushEditIcon,"mousedown":_vm.pushEditIcon}}),_vm._v(" "),_c('img',{class:{openHamburger: _vm.state.hamburger},attrs:{"id":"hun","src":__webpack_require__("A9wT")},on:{"touchstart":_vm.hamburger,"mousedown":_vm.hamburger}})]),_vm._v(" "),_c('div',{attrs:{"id":"mid"}},[_c('img',{attrs:{"id":"puyo-field","src":__webpack_require__("FMDN")}}),_vm._v(" "),_c('img',{staticClass:"puyo",staticStyle:{"top":"32px","left":"64px"},attrs:{"src":__webpack_require__("K7Qp")}}),_vm._v(" "),(!_vm.state.editView)?_c('img',{staticClass:"puyo",style:(_vm.opsAxisStyle),attrs:{"src":_vm.opsAxisSrc}}):_vm._e(),_vm._v(" "),(!_vm.state.editView)?_c('img',{staticClass:"puyo",style:(_vm.opsSubStyle),attrs:{"src":_vm.opsSubSrc}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.puyoObjs),function(obj){return _c('img',{staticClass:"puyo",style:(_vm.puyoStyle(obj)),attrs:{"src":_vm.puyoSrc(obj)}})}),_vm._v(" "),_vm._l((_vm.puyoFieldTouchObjs),function(obj){return _c('div',{style:(_vm.puyoFieldTouchStyle(obj)),on:{"touchstart":function($event){_vm.puyoFieldTouch($event, obj)},"mousedown":function($event){_vm.puyoFieldTouch($event, obj)}}})}),_vm._v(" "),_c('div',{attrs:{"id":"sub-field"}},[_c('div',{attrs:{"id":"next-area"}},_vm._l((_vm.nextPuyos),function(obj,index){return _c('img',{staticClass:"puyo",style:(_vm.nextPuyoStyle(obj)),attrs:{"src":_vm.puyoSrc(obj)},on:{"touchstart":function($event){_vm.toggleNext($event, index)},"mousedown":function($event){_vm.toggleNext($event, index)}}})})),_vm._v(" "),_c('div',{attrs:{"id":"ojama-image-area"}}),_vm._v(" "),(_vm.state.editView)?_c('div',{staticStyle:{"position":"absolute","top":"0px","left":"0px","width":"128px","height":"64px","background-color":"#ffffff"}},[_vm._l((_vm.editPuyos),function(obj,index){return _c('img',{staticClass:"puyo",style:(_vm.nextPuyoStyle(obj)),attrs:{"src":_vm.puyoSrc(obj)}})}),_vm._v(" "),_vm._l((_vm.editPuyos),function(obj){return _c('div',{style:(_vm.editPuyoTouchStyle(obj)),on:{"touchstart":function($event){_vm.editPuyoTouch($event, obj)},"mousedown":function($event){_vm.editPuyoTouch($event, obj)}}})})],2):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"info-area"}},[_c('div',{attrs:{"id":"turn-view"}},[_vm._v(_vm._s(_vm.state.turn + 1)+"手目")]),_vm._v(" "),_c('div',{attrs:{"id":"chain-view"}},[_vm._v(_vm._s(_vm.state.chain)+"連鎖 "+_vm._s(_vm.state.score)+"点")]),_vm._v(" "),_c('div',{attrs:{"id":"score-view"}},[_vm._v("合計 "+_vm._s(_vm.state.sumScore)+"点")]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","top":"5px","left":"10px"},attrs:{"src":__webpack_require__("NyqP")},on:{"touchstart":_vm.b_prev,"mousedown":_vm.b_prev}}),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","top":"5px","left":"96px"},attrs:{"src":__webpack_require__("LagP")},on:{"touchstart":_vm.b_next,"mousedown":_vm.b_next}})]),_vm._v(" "),_c('div',{attrs:{"id":"chart-area"}},_vm._l((_vm.state.history),function(obj,index){return _c('div',{staticClass:"chart-tile",class:{activeTile: index===_vm.state.turn},on:{"touchstart":function($event){_vm.b_chart($event, index)},"mousedown":function($event){_vm.b_chart($event, index)}}},[_c('div',{staticClass:"chart-num",style:(obj.isEdit?'color:#ff0000; font-weight:bold;':'')},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('img',{staticClass:"puyo",staticStyle:{"left":"28px"},attrs:{"src":_vm.puyoHistoryAxisSrc(obj, index)}}),_vm._v(" "),_c('img',{staticClass:"puyo",staticStyle:{"left":"60px"},attrs:{"src":_vm.puyoHistorySubSrc(obj, index)}}),_vm._v(" "),_c('div',{staticClass:"chart-pos"},[_vm._v(_vm._s((obj.x>0&&obj.x<7)?obj.x:''))]),_vm._v(" "),_c('div',{staticClass:"chart-dir"},[_vm._v(_vm._s((obj.dir===0)?'↑':(obj.dir===1)?'→':(obj.dir===2)?'↓':(obj.dir===3)?'←':''))]),_vm._v(" "),_c('div',{staticClass:"leftEditChart",on:{"touchstart":function($event){_vm.editChartLeft($event, index)},"mousedown":function($event){_vm.editChartLeft($event, index)}}}),_vm._v(" "),_c('div',{staticClass:"rightEditChart",on:{"touchstart":function($event){_vm.editChartRight($event, index)},"mousedown":function($event){_vm.editChartRight($event, index)}}})])}))])],2),_vm._v(" "),_c('div',{attrs:{"id":"bottom"}},[_c('div',{staticClass:"bt",on:{"touchstart":_vm.b_left,"mousedown":_vm.b_left,"touchend":_vm.b_untouch,"mouseup":_vm.b_untouch,"mouseout":_vm.b_untouch}},[_vm._v("←")]),_vm._v(" "),_c('div',{staticClass:"bt",on:{"touchstart":_vm.b_down,"mousedown":_vm.b_down,"touchend":_vm.b_untouch,"mouseup":_vm.b_untouch,"mouseout":_vm.b_untouch}},[_vm._v("↓")]),_vm._v(" "),_c('div',{staticClass:"bt",on:{"touchstart":_vm.b_right,"mousedown":_vm.b_right,"touchend":_vm.b_untouch,"mouseup":_vm.b_untouch,"mouseout":_vm.b_untouch}},[_vm._v("→")]),_vm._v(" "),_c('div',{staticClass:"bt",on:{"touchstart":_vm.b_turnLeft,"mousedown":_vm.b_turnLeft,"touchend":_vm.b_untouch,"mouseup":_vm.b_untouch,"mouseout":_vm.b_untouch}},[_vm._v("L")]),_vm._v(" "),_c('div',{staticClass:"bt",on:{"touchstart":_vm.b_turnRight,"mousedown":_vm.b_turnRight,"touchend":_vm.b_untouch,"mouseup":_vm.b_untouch,"mouseout":_vm.b_untouch}},[_vm._v("R")])]),_vm._v(" "),(_vm.state.loginView)?_c('div',{staticClass:"loginView"},[_c('div',{staticClass:"loginTile",on:{"touchstart":_vm.login,"mousedown":_vm.login}},[_vm._v("ログイン")]),_vm._v(" "),_c('div',{staticClass:"loginTile",on:{"touchstart":_vm.logout,"mousedown":_vm.logout}},[_vm._v("ログアウト")])]):_vm._e(),_vm._v(" "),(_vm.state.hamburger)?_c('div',{attrs:{"id":"menu"}},[_c('div',{attrs:{"id":"menu_back"}}),_vm._v(" "),_c('div',{attrs:{"id":"menu_area_back"}}),_vm._v(" "),_c('div',{attrs:{"id":"menu_area"}},[_c('div',{staticClass:"menu_tile",on:{"touchstart":_vm.tReset,"mousedown":_vm.tReset}},[_vm._v("初手に戻す")]),_vm._v(" "),_c('div',{staticClass:"menu_tile",on:{"touchstart":_vm.tInit,"mousedown":_vm.tInit}},[_vm._v("ツモを変えてリセット")]),_vm._v(" "),_c('div',{staticClass:"menu_tile",on:{"touchstart":_vm.tCreateGif,"mousedown":_vm.tCreateGif}},[_vm._v("現在手までのGIF画像を作成")]),_vm._v(" "),_c('div',{staticClass:"menu_tile",on:{"touchstart":_vm.tTweet,"mousedown":_vm.tTweet}},[_vm._v("ぷよ譜をツイートする")]),_vm._v(" "),_c('div',{staticClass:"menu_tile",on:{"touchstart":_vm.tConfig,"mousedown":_vm.tConfig}},[_vm._v("詳細設定")]),_vm._v(" "),_c('div',{attrs:{"id":"chartDescription"}},[_vm._v("現在のぷよ譜↓")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.chartURL),expression:"chartURL"}],attrs:{"readonly":"","id":"chartArea"},domProps:{"value":(_vm.chartURL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chartURL=$event.target.value}}}),_vm._v(" "),(_vm.state.gifView)?_c('div',{attrs:{"id":"gifView"}},[_c('img',{staticStyle:{"margin-top":"5px"},attrs:{"src":_vm.state.gifSrc}}),_vm._v(" "),(_vm.state.gifSrc==null)?_c('div',{staticStyle:{"position":"absolute","top":"150px","left":"75px"}},[_vm._v("画像生成中...")]):_vm._e(),_vm._v(" "),(_vm.state.gifSrc!=null)?_c('a',{staticStyle:{"margin-top":"5px"},attrs:{"id":"dl","href":_vm.state.gifSrc,"download":"chart.gif"}},[_vm._v("download")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.state.tweetView)?_c('div',{attrs:{"id":"menu_area_tweet"}},[_vm._m(1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.tweetText),expression:"state.tweetText"}],attrs:{"id":"menu_area_tweet_text"},domProps:{"value":(_vm.state.tweetText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state.tweetText=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"menu_area_tweet_checkarea"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.tweetChecked),expression:"state.tweetChecked"}],attrs:{"type":"checkbox","id":"menu_area_tweet_check"},domProps:{"checked":Array.isArray(_vm.state.tweetChecked)?_vm._i(_vm.state.tweetChecked,null)>-1:(_vm.state.tweetChecked)},on:{"touchstart":_vm.clickTweetCheck,"__c":function($event){var $$a=_vm.state.tweetChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.state.tweetChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.state.tweetChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.state.tweetChecked=$$c}}}}),_vm._v("\n          現在手までのGIF画像を添付\n        ")]),_vm._v(" "),_c('button',{staticClass:"menu_area_tweet_button",class:{tweetProcessing: _vm.state.gifProcessing},attrs:{"type":"button"},on:{"touchstart":_vm.bTweet,"mousedown":_vm.bTweet}},[_vm._v(_vm._s((_vm.state.gifProcessing)?'画像生成中':'ツイート'))])]):_vm._e(),_vm._v(" "),(_vm.state.configView)?_c('div',{attrs:{"id":"menu_area_config"}},[_c('div',{attrs:{"id":"configCaptionSpeed"}},[_vm._v("連鎖スピード")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.chainSpeed),expression:"state.chainSpeed"}],attrs:{"id":"configSpeedBar","type":"range","min":"1","max":"100","step":"1"},domProps:{"value":(_vm.state.chainSpeed)},on:{"__r":function($event){_vm.state.chainSpeed=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"configSpeedStr"}},[_vm._v(_vm._s(_vm.state.chainSpeed))]),_vm._v(" "),_c('div',{attrs:{"id":"configCaptionRevision"}},[_vm._v("ツモ補正（未実装）")]),_vm._v(" "),_c('div',{attrs:{"id":"configRevision"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.revision),expression:"state.revision"}],attrs:{"type":"radio","name":"configRevision","value":"random","disabled":"disabled"},domProps:{"checked":_vm._q(_vm.state.revision,"random")},on:{"__c":function($event){_vm.state.revision="random"}}}),_vm._v("完全ランダム"),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.revision),expression:"state.revision"}],attrs:{"type":"radio","name":"configRevision","value":"tu","disabled":"disabled"},domProps:{"checked":_vm._q(_vm.state.revision,"tu")},on:{"__c":function($event){_vm.state.revision="tu"}}}),_vm._v("通仕様（128手均等）"),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.revision),expression:"state.revision"}],attrs:{"type":"radio","name":"configRevision","value":"classic","disabled":"disabled"},domProps:{"checked":_vm._q(_vm.state.revision,"classic")},on:{"__c":function($event){_vm.state.revision="classic"}}}),_vm._v("クラシック仕様（16手均等）\n        ")]),_vm._v(" "),_c('div',{attrs:{"id":"configSpeedStr"}},[_vm._v(_vm._s(_vm.state.chainSpeed))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"right_content"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"keyboard-description"}},[_c('div',{attrs:{"id":"keyboar-description-title"}},[_vm._v("キーボード操作")]),_vm._v(" "),_c('table',{staticClass:"descriptionTable"},[_c('tr',[_c('td',[_vm._v("[←][→]")]),_c('td',[_vm._v("左右移動")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[Z][X]")]),_c('td',[_vm._v("左右回転")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[↓]")]),_c('td',[_vm._v("設置")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[↑]")]),_c('td',[_vm._v("１手戻る")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[N]")]),_c('td',[_vm._v("１手進む")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[R]")]),_c('td',[_vm._v("初手に戻る")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[T]")]),_c('td',[_vm._v("ツモを変えてリセット")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[E]")]),_c('td',[_vm._v("編集モード")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("[1-8]")]),_c('td',[_vm._v("ぷよ種選択（編集モード）")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"menu_area_tweet_desc"}},[_vm._v("リンクをあなたの"),_c('br'),_vm._v("フォロワーに共有する")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bcqc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAse31CmNwAAANRJREFUWMPtlz0OwjAMhWOrOxISnXo9zpAr0DNwNEaYsnGCxxTJQvlpWuJEIp7bvi/PbvRMAExJrTQnX7BwVPK9qVT0upw2P7sFhnIOrDQjJxqr++udhYgC+JPsFZcQKTeCAEdOXeoGa4h7J0MDzBriKQg2jYu1Th9zgQCoics6Px/UtAXeheYzQDdzUbdf3g39/AUDYAD8L4CFIx8atO8AC0ejBezzmmYbZDxjGaE1IL6zYV8zUNuFUDLm0GpVAyIWy/tcTLpYzfY6Itv3k+W09nr+AevjmsxxfmwqAAAAAElFTkSuQmCC"

/***/ }),

/***/ "CI1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var axios = __webpack_require__("mtWM");
var firebase = __webpack_require__("It2I");
__webpack_require__("YtIj");
__webpack_require__("/f1z");
var config = {
  apiKey: 'AIzaSyDabZ3U6CSSsdMnjoFqPC-k8Fu4qV4LTrk',
  authDomain: 'puyosim-95050.firebaseapp.com',
  databaseURL: 'https://puyosim-95050.firebaseio.com',
  projectId: 'puyosim-95050',
  storageBucket: 'puyosim-95050.appspot.com',
  messagingSenderId: '234335971'
};
firebase.initializeApp(config);
var provider = new firebase.auth.TwitterAuthProvider();

// firebase.auth().useDeviceLanguage()

firebase.auth().getRedirectResult().then(function (result) {
  // console.log('redirectResult()', result)
  if (result.credential) {
    var t = result.credential.accessToken;
    var s = result.credential.secret;
    var uid = result.user.uid;
    firebase.database().ref('users/' + uid + '/tw_key').set(t);
    firebase.database().ref('users/' + uid + '/tw_skey').set(s);
    firebase.database().ref('users/' + uid + '/tw_dispName').set(result.user.displayName);
    // console.log(result.credentia)
  }
  // The signed-in user info.
  // console.log(result.user)
}).catch(function (error) {
  console.log(error);
});

var loginFunc = function loginFunc() {};
var logoutFunc = function logoutFunc() {};
var isLogin = false;
var key = null;
var skey = null;
firebase.auth().onAuthStateChanged(function (user) {
  // console.log('auth state changed!', user)
  if (user) {
    loginFunc(user);
    isLogin = true;
    firebase.database().ref('/users/' + user.uid).once('value').then(function (snapshot) {
      var val = snapshot.val();
      key = val.tw_key;
      skey = val.tw_skey;
    });
  } else {
    logoutFunc();
    isLogin = false;
  }
});

var FB = function () {
  function FB() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FB);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FB, [{
    key: 'login',
    value: function login() {
      firebase.auth().signInWithRedirect(provider);
    }
  }, {
    key: 'logout',
    value: function logout() {
      firebase.auth().signOut();
    }
  }, {
    key: 'onLogin',
    value: function onLogin(f) {
      loginFunc = f;
    }
  }, {
    key: 'onLogout',
    value: function onLogout(f) {
      logoutFunc = f;
    }
  }, {
    key: 'tweet',
    value: function tweet(status, base64str, callback) {
      if (base64str == null) base64str = null;
      if (!isLogin) {
        callback(false);
        return;
      }
      axios.post('https://api.refpuyo.net/tweet', {
        key: key,
        skey: skey,
        status: status,
        data: base64str
      }).then(function (response) {
        // console.log(response)
        if (callback != null) callback(true);
      }).catch(function (error) {
        console.log(error);
        if (callback != null) callback(false);
      });
    }
  }]);

  return FB;
}();

/* harmony default export */ __webpack_exports__["a"] = (FB);

/***/ }),

/***/ "FLKx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAs5eloTXAAAAM1JREFUWMPtlzEShCAMRU2OIuVWnmFb5a4LtWfYakvOghUzDBNAdAnMCLX6Hz8x8wPW2qnkCLUlXzBSQ8n34AyAL/pefsln9++rCCYLINRmc6IpmBxEFMDd+qp46EgMhAS4c+tSN5BD3DlJNTByiKcgcGp8kOv2MReQU5yaJc1K4Fxo3gMwf1ZW+8PZ0M9fMAAGwHMBjNTgxyjOGWCkhlECdHmNswx+PEM/QnNAhNmwrx6o7QKVjJFarWpAxGJ5n4tJF6vZVUf+vpzWXs8P0sWYZtA2OhMAAAAASUVORK5CYII="

/***/ }),

/***/ "FMDN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "IPdy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAA3NCSVQICAjb4U/gAAAAX0lEQVRIiWPsYBBloCVgYWBgMKxyQhM937YPzsaUJagAWZYJq7WGVU5YzSVSAbIsdgtwOY0kBRBZfBZQBYxaMAIsYBzNyYRkR3PyqAWjFowWFUTIjhYVoxYMAQtonpMBzIg2to0F2yoAAAAASUVORK5CYII="

/***/ }),

/***/ "K7Qp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoXDyYUROoFZAAAAMNJREFUWMPtl9ENhDAMQxOLGW5VZmBVlih/J92JtoljqXzQP1Bkv1KTgLfWbOWCLV4vwPZ/4/DPNxR7O71qMNNDr/juumLe00NWhDUvZSALkan/ARideVR0VDfNQBUia949AgaCMR9mIAPBmk9DGIGomJuZeWQYMa9itIlBKcbUQy2ahYVyZ8zsSAFU+kAZQNEJnz8LlB1OMg0j5lUIKHZegYDqsbMQUJ05CwGVOQvx/FnAfppT0zCTbgbiTs/fn9PVABf09KLWKin4DAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "LagP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANCAYAAACtpZ5jAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoMESQltqI5OAAAAJJJREFUOMut09EJAyEMBuA/R8AxnMQ3J+kYheLDQce4ZTKJYwhC+iRYelfUXF4D3x8TpFwLAMCz05QSHq8n4YbaGioiiDHCs1PPTo/9rRaYAKiInDZDCACAlZfwv2Yf6NnpTAiPTjAbwiv7Gwlh6/WvQsxwf+Bci23iK2xpxyPYMDyLfcG5Fmo/z4r9TNxwK9bXB7FBVq3z8+raAAAAAElFTkSuQmCC"

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4771f676_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("AtdP");
function injectStyle (ssrContext) {
  __webpack_require__("9vzG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4771f676_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: 'UA-108713235-1'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NyqP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANCAYAAACtpZ5jAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoMESQWCXJYLgAAAJhJREFUOMu1lMEJAzEMBFeHwWW4kv25kpQRyMMEUkYq8U+VqAyDwXkd5MCGS+zTTyBmF6SVWC1YUe/nq6WUYLUIAGyzsOB8C863GCNUFcH5BgDyq+PdGQCoaneG5DnHPWcj6F7bStgQPAs7gFfCDuDb4y5Wi1gtknMGSZCcB383K0WGy5sVOXVu/4jITKR7YSEJq0Xkql/xAYS0h85wEUvUAAAAAElFTkSuQmCC"

/***/ }),

/***/ "VrRu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAwZDnWlUwAAANFJREFUWMPtl0EKAyEMRU32PVbBtfd0tg7MrXqB30URbIlap0wiVMHdaF5+MvJDANzI2jdqHvABNHIffQNQBvX3zrfHIAyA5k7RAY9zO0WH3v1VBXLWvYy76h1tNUSAfSP8GlgCkSBYI3hWUmpg1gjegmBnvFgr+5oKBEAt+Nu6vRrSrARZBfMeoBSdvvzF2zDPX7AAFsD/AvgAKm2U5hvgA2iVgLNf0yxDac+4tNAaEJ/ecK4euFoFyRmzNFpdAVGz5eaDybyj2VlFRodTsh7Pn8CkNJQ988m9AAAAAElFTkSuQmCC"

/***/ }),

/***/ "d7Vi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QoXDyEVfKyjNQAAALxJREFUWMPtV8ENxCAMi6MbhP2nYhP3FQlVAUrvCEhH3m3tOGlkg6SMFIDmCyQx8r3PKGhK6fGzT8igpwAA9kBrlXPukqgSsE7egpckWmq4BL7pelQNjQA3Jb0F1gjwFgmVxaVR3ddU0Ehw75YsG4GpsHwHICKh8t9vwz5/wSFwCPwvAZIw0xB9A0jijEDNr0WOobRnWlroCBJ3b7jXDsxWwXPG6kWrGSRqtnzPYLJFNHurSDm+n4TT2fH8Asj2lr/PU21wAAAAAElFTkSuQmCC"

/***/ }),

/***/ "fBFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__ = __webpack_require__("5oUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_puyo_Game__ = __webpack_require__("5+Oq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gif_js_optimized__ = __webpack_require__("Mqf3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gif_js_optimized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gif_js_optimized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_FB__ = __webpack_require__("CI1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_Util__ = __webpack_require__("qtin");

// import Util from './libs/PuyoUtil'

var game = void 0;


var fb = new __WEBPACK_IMPORTED_MODULE_3__libs_FB__["a" /* default */]();


fb.onLogin(function (user) {
  state.isLoginWait = false;
  state.isLogin = true;
  state.userName = user.displayName;
});

fb.onLogout(function () {
  state.isLoginWait = false;
  state.isLogin = false;
});

var state = {
  title: 'ぷよシミュWeb | スマホ・PC両対応のとこぷよシミュレータ',
  ops: {
    pos: {
      x: -1,
      y: -1
    },
    dir: -1,
    available: true
  },
  puyoObjs: [],
  nextPuyoPairs: [],
  nextDisplayNum: 4, // 廃止予定
  nextDisplay: [{ axis: true, sub: true }, { axis: true, sub: true }, { axis: false, sub: false }, { axis: false, sub: false }],
  turn: -1,
  chain: 0,
  score: 0,
  sumScore: 0,
  history: [],
  hamburger: false,
  gifSrc: null,
  gifView: false,
  gifProcessing: false,
  hashStr: '',
  chartView: false,
  isLoginWait: true,
  isLogin: false,
  userName: '',
  tweetView: false,
  tweetText: '',
  tweetChecked: true,
  configView: false,
  chainSpeed: 50,
  revision: 'random',
  statusStr: '',
  editView: false,
  editKind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.RED,
  loginView: false,
  statisticsMaxChain: 0,
  statisticsMaxScore: 0,
  statisticsMaxConcurrent: 0,
  statisticsAllClear: 0,
  statisticsCount: 0,
  nazoStatusStr: '',
  nazoCondition: {},
  nazoMode: '未設定',
  nazoAllClear: 1,
  nazoTurn: 3,
  nazoChain: 4,
  nazoConcurrent: 5,
  nazoCount: 6,
  nazoClear: false
};

function init(hash) {
  game = new __WEBPACK_IMPORTED_MODULE_1__libs_puyo_Game__["a" /* default */]();
  if (hash != null) {
    if (hash.substring(0, 1) === '#') {
      hash = hash.slice(1);
    }
    var toks = hash.split('!');
    if (toks[0] != null && toks[0].length > 0) {
      game.setNextSeed(__WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[0].slice(0, 4)));
    }
    if (toks[1] != null && toks[1].length > 0) {
      var cs = getChartFromHash(toks[1].slice(0, 1000));
      for (var i = 0; i < cs.length; i++) {
        game.chart.set(i, cs[i].set.x, cs[i].set.dir);
        if (cs[i].editField != null) game.chart.setEditedField(i, cs[i].editField);
      }
    }
    if (toks[2] != null && toks[2].length > 0) {
      for (var _i = 0; _i < toks[2].length; _i += 2) {
        var akind = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64ctoNum(toks[2][_i]);
        var skind = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64ctoNum(toks[2][_i + 1]);
        game.editNext(_i / 2, akind, true);
        game.editNext(_i / 2, skind, false);
      }
    }
    if (toks[3] != null && toks[3].length > 0) {
      switch (toks[3].slice(0, 1)) {
        case 'a':
          state.nazoTurn = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[3].slice(1));
          state.nazoMode = '全消し';
          break;
        case 'b':
          state.nazoTurn = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[3].slice(1));
          state.nazoMode = '連鎖';
          break;
        case 'c':
          state.nazoTurn = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[3].slice(1));
          state.nazoMode = '同時消し';
          break;
        case 'd':
          state.nazoTurn = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[3].slice(1));
          state.nazoMode = '個数';
          break;
      }
    }
    if (toks[4] != null && toks[4].length > 0) {
      switch (state.nazoMode) {
        case '未設定':
          break;
        case '全消し':
          state.nazoClear = 1;break;
        case '連鎖':
          state.nazoChain = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[4]);break;
        case '同時消し':
          state.nazoConcurrent = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[4]);break;
        case '個数':
          state.nazoCount = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64stoNum(toks[4]);break;
      }
    }
  }
  game.moveTurn(game.chart.size() - 1, true);
  updateNext();
  updateField();
  updateOps();
  updateInfo();
}
init(window.location.hash);

var lastTurnMs = 0;

function updateNext() {
  var na = [];
  for (var i = 0; i < game.next.size(); i++) {
    var axis = game.next.get(i).axis;
    var sub = game.next.get(i).sub;
    na.push({
      axis: axis,
      sub: sub
    });
  }
  state.nextPuyoPairs = na;
}

function updateField() {
  var objs = [];
  for (var y = game.field.Height(); y > 0; y--) {
    for (var x = 1; x <= game.field.Width(); x++) {
      var kind = game.field.get(new __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Pos(x, y));
      objs.push({
        pos: new __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Pos(x, y),
        kind: kind
      });
    }
  }
  state.puyoObjs = objs;
}

function updateOps() {
  state.ops = {
    pos: {
      x: game.ops.pos.x,
      y: game.ops.pos.y
    },
    dir: game.ops.dir,
    available: game.ops.available
  };
}

function updateInfo() {
  state.turn = game.turn;
  state.chain = game.chain;
  state.score = game.score;
  state.sumScore = game.sumScore;
  var h = [];
  for (var i = 0; i < game.chart.size(); i++) {
    var ch = game.chart.get(i);
    h.push({
      x: ch.x,
      dir: ch.dir,
      isEdit: game.chart.getEditedField(i) != null
    });
  }
  state.history = h;
  state.hashStr = getHashStr();
  window.location.hash = state.hashStr;
  state.statisticsMaxChain = game.statisticsMaxChain;
  state.statisticsMaxScore = game.statisticsMaxScore;
  state.statisticsMaxConcurrent = game.statisticsMaxConcurrent;
  state.statisticsAllClear = game.statisticsAllClear;
  state.statisticsCount = game.statisticsCount;
  state.nazoClear = checkNazoClear();
}

function checkNazoClear() {
  switch (state.nazoMode) {
    case '未設定':
      return false;
    case '全消し':
      return game.turn <= state.nazoTurn && game.statisticsAllClear > 0;
    case '連鎖':
      return game.turn <= state.nazoTurn && state.nazoChain <= game.statisticsMaxChain;
    case '同時消し':
      return game.turn <= state.nazoTurn && state.nazoConcurrent <= game.statisticsMaxConcurrent;
    case '個数':
      return game.turn <= state.nazoTurn && state.nazoCount <= game.statisticsCount;
  }
  return false;
}

function _getChartFromHash(c) {
  switch (__WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].base64ctoNum(c)) {
    case 0:
      return { type: 'set', x: null, dir: null };
    case 1:
      return { type: 'set', x: 1, dir: 0 };
    case 2:
      return { type: 'set', x: 1, dir: 1 };
    case 3:
      return { type: 'set', x: 1, dir: 2 };
    case 4:
      return { type: 'set', x: 1, dir: 3 };
    case 5:
      return { type: 'set', x: 2, dir: 0 };
    case 6:
      return { type: 'set', x: 2, dir: 1 };
    case 7:
      return { type: 'set', x: 2, dir: 2 };
    case 8:
      return { type: 'set', x: 2, dir: 3 };
    case 9:
      return { type: 'set', x: 3, dir: 0 };
    case 10:
      return { type: 'set', x: 3, dir: 1 };
    case 11:
      return { type: 'set', x: 3, dir: 2 };
    case 12:
      return { type: 'set', x: 3, dir: 3 };
    case 13:
      return { type: 'set', x: 4, dir: 0 };
    case 14:
      return { type: 'set', x: 4, dir: 1 };
    case 15:
      return { type: 'set', x: 4, dir: 2 };
    case 16:
      return { type: 'set', x: 4, dir: 3 };
    case 17:
      return { type: 'set', x: 5, dir: 0 };
    case 18:
      return { type: 'set', x: 5, dir: 1 };
    case 19:
      return { type: 'set', x: 5, dir: 2 };
    case 20:
      return { type: 'set', x: 5, dir: 3 };
    case 21:
      return { type: 'set', x: 6, dir: 0 };
    case 22:
      return { type: 'set', x: 6, dir: 1 };
    case 23:
      return { type: 'set', x: 6, dir: 2 };
    case 24:
      return { type: 'set', x: 6, dir: 3 };
    case 25:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.BRANK };
    case 26:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.RED };
    case 27:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.GREEN };
    case 28:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.BLUE };
    case 29:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.YELLOW };
    case 30:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.PURPLE };
    case 31:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.IRON };
    case 32:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.OJAMA };
    case 33:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.WALL };
    case 34:
      return { type: 'edit', kind: __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.PEKE };
  }
  return {};
}
function arrayToField(array) {
  var field = new __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Field();
  for (var i = 0; i < array.length; i++) {
    var x = i % 6 + 1;
    var y = Math.floor(i / 6) + 1;
    field.set(new __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Pos(x, y), array[i]);
  }
  return field;
}
function getChartFromHash(hashStr) {
  var editArray = [];
  var charts = [];
  for (var i = 0; i < hashStr.length; i++) {
    var c = hashStr[i];
    var obj = _getChartFromHash(c);
    switch (obj.type) {
      case 'set':
        charts.push({ set: { x: obj.x, dir: obj.dir } });
        if (editArray.length > 0) {
          charts[charts.length - 1].editField = arrayToField(editArray);
          editArray = [];
        }
        break;
      case 'edit':
        editArray.push(obj.kind);
        break;
    }
  }
  return charts;
}
function _getHashFromChart(ch) {
  if (ch.x == null || ch.dir == null) return __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64c(0);
  var n = 4 * (ch.x - 1) + ch.dir + 1;
  return __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64c(n);
}
function _getHashFromChartEdit(field) {
  if (field == null) return '';
  var s = '';
  for (var y = 1; y <= field.Height(); y++) {
    for (var x = 1; x <= field.Width(); x++) {
      var kind = field.get(new __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Pos(x, y));
      s += __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64c(25 + kind);
    }
  }
  for (var i = s.length - 1; i >= 0; i--) {
    if (s[i] !== 'z') break;
    s = s.slice(0, -1);
  }
  return s;
}
function _getHashNextEdit(next, orgNext) {
  var s = '';
  var editedFlag = false;
  for (var i = next.size() - 1; i >= 0; i--) {
    var pp = next.get(i);
    var op = orgNext.get(i);
    if (pp.axis !== op.axis || pp.sub !== op.sub) editedFlag = true;
    if (editedFlag) {
      s += __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64c(pp.sub);
      s += __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64c(pp.axis);
    }
  }
  return s.split('').reverse().join('');
}
function _getHashNazo() {
  switch (state.nazoMode) {
    case '未設定':
      return '';
    case '全消し':
      return 'a' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoTurn) + '!';
    case '連鎖':
      return 'b' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoTurn) + '!' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoChain);
    case '同時消し':
      return 'c' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoTurn) + '!' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoConcurrent);
    case '個数':
      return 'd' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoTurn) + '!' + __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(state.nazoCount);
  }
  return '';
}
function getHashStr() {
  var chart = game.chart;
  var str = __WEBPACK_IMPORTED_MODULE_4__libs_Util__["a" /* default */].numToBase64s(game.next.seed()) + '!';
  for (var i = 0; i < chart.size(); i++) {
    str += _getHashFromChartEdit(chart.getEditedField(i));
    str += _getHashFromChart(chart.get(i));
  }
  var ne = _getHashNextEdit(game.next, game.orgNext);
  str += '!';
  if (ne.length > 0) str += ne;
  var nazo = _getHashNazo(game.next, game.orgNext);
  if (nazo.length > 0) str += '!' + nazo;
  return str;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  setTitle: function setTitle(title) {
    this.state.title = title;
  },

  init: init,
  turnLeft: function turnLeft() {
    if (!game.ops.available) return;
    if (state.editView) return;
    if (!game.rotateLeft()) {
      var nowMs = new Date().getTime();
      if (nowMs - lastTurnMs < 1000) {
        game.rotateLeftQuick();
        lastTurnMs = 0;
      } else {
        lastTurnMs = nowMs;
      }
    }
    updateOps();
  },
  turnRight: function turnRight() {
    if (!game.ops.available) return;
    if (state.editView) return;
    if (!game.rotateRight()) {
      var nowMs = new Date().getTime();
      if (nowMs - lastTurnMs < 1000) {
        game.rotateRightQuick();
        lastTurnMs = 0;
      } else {
        lastTurnMs = nowMs;
      }
    }
    updateOps();
  },
  moveLeft: function moveLeft() {
    if (!game.ops.available) return;
    if (state.editView) return;
    game.moveLeft();
    updateOps();
  },
  moveRight: function moveRight() {
    if (!game.ops.available) return;
    if (state.editView) return;
    game.moveRight();
    updateOps();
  },
  setDown: function setDown() {
    if (!game.ops.available) return;
    if (state.editView) return;
    game.setDown();
    if (game.existNextStep()) {
      setTimeout(function () {
        this.nextStep();
      }.bind(this), 1000 - state.chainSpeed * 10);
    }
    updateOps();
    updateField();
    updateInfo();
  },
  nextStep: function nextStep() {
    var cf = game.field.canFire();
    var before = game.field.copy();
    game.nextStep();
    var after = game.field.copy();
    if (game.existNextStep()) {
      setTimeout(function () {
        this.nextStep();
      }.bind(this), 1000 - state.chainSpeed * 10);
    } else {
      setTimeout(function () {
        updateField(); // TODO: やばい…
      }, 1000 - state.chainSpeed * 10);
    }
    updateOps();
    updateField();
    updateInfo();
    if (cf) {
      // 消えたぷよの表示用処理
      for (var i = 0; i < state.puyoObjs.length; i++) {
        var pos = state.puyoObjs[i].pos;
        if (!before.isBrank(pos) && after.isBrank(pos)) {
          state.puyoObjs[i].state = 'extinction'; // TODO: 定義が散らかってやばいので修正
        }
      }
    }
  },
  moveTurn: function moveTurn(turnNum) {
    game.saveField();
    game.moveTurn(turnNum, true);
    updateOps();
    updateField();
    updateInfo();
  },
  moveTurnPrev: function moveTurnPrev() {
    game.saveField();
    game.moveTurn(game.turn - 1, true);
    updateOps();
    updateField();
    updateInfo();
  },
  moveTurnNext: function moveTurnNext() {
    game.saveField();
    game.moveTurn(game.turn + 1, true);
    updateOps();
    updateField();
    updateInfo();
  },
  toggleNextDisplay: function toggleNextDisplay(pos, isAxis) {
    if (isAxis) {
      state.nextDisplay[pos].axis = !state.nextDisplay[pos].axis;
    } else {
      state.nextDisplay[pos].sub = !state.nextDisplay[pos].sub;
    }
  },
  toggleHamburger: function toggleHamburger() {
    if (state.hamburger) {
      this.closeHamburger();
    } else {
      this.openHamburger();
    }
  },
  closeHamburger: function closeHamburger() {
    state.hamburger = false;
    this.closeGifView();
    this.closeChartView();
    this.closeTweetView();
    this.closeConfigView();
  },
  openHamburger: function openHamburger() {
    state.hamburger = true;
  },
  createGif: function createGif() {
    // console.log('createGif!')
    if (state.gifProcessing === true) return;
    state.gifProcessing = true;
    // console.log('start')

    var gif = new __WEBPACK_IMPORTED_MODULE_2_gif_js_optimized___default.a({
      repeat: -1,
      width: 192 + 64,
      height: 416
    });

    var cv = document.createElement('canvas');
    cv.width = 192 + 64;
    cv.height = 416;
    var ctx = cv.getContext('2d');

    var back = new Image();
    back.src = __webpack_require__("FMDN");
    var pr = new Image();
    pr.src = __webpack_require__("Bcqc");
    var pg = new Image();
    pg.src = __webpack_require__("FLKx");
    var pb = new Image();
    pb.src = __webpack_require__("jzv+");
    var py = new Image();
    py.src = __webpack_require__("VrRu");
    var pp = new Image();
    pp.src = __webpack_require__("8h30");
    var po = new Image();
    po.src = __webpack_require__("+gtd");
    var pi = new Image();
    pi.src = __webpack_require__("d7Vi");
    var pw = new Image();
    pw.src = __webpack_require__("IPdy");

    var turn = game.turn;
    for (var i = 0; i <= turn; i++) {
      ctx.drawImage(back, 0, 0);
      game.moveTurn(i, true);
      // Field
      for (var y = 1; y <= game.field.height; y++) {
        for (var x = 1; x <= game.field.width; x++) {
          var k = game.field.get(new __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Pos(x, y));
          var xx = (x - 1) * 32;
          var yy = (13 - y) * 32;
          this._drawPuyo(ctx, xx, yy, k);
        }
      }
      // 現在手
      var ap = game.axisPos();
      var sp = game.subPos();
      if (ap != null || ap.x > 0) {
        var _pp = game.next.get(i);
        var _xx = (ap.x - 1) * 32;
        var _yy = (13 - ap.y) * 32;
        this._drawPuyo(ctx, _xx, _yy, _pp.axis);
        _xx = (sp.x - 1) * 32;
        _yy = (13 - sp.y) * 32;
        this._drawPuyo(ctx, _xx, _yy, _pp.sub);
      }
      // NEXT
      var n1pp = game.next.get(i + 1);
      var n2pp = game.next.get(i + 2);
      this._drawPuyo(ctx, 192, 32, n1pp.axis);
      this._drawPuyo(ctx, 192, 0, n1pp.sub);
      this._drawPuyo(ctx, 224, 32, n2pp.axis);
      this._drawPuyo(ctx, 224, 0, n2pp.sub);
      gif.addFrame(cv, { copy: true, delay: (101 - state.chainSpeed) * 10 });
    }

    gif.on('finished', function (blob) {
      var reader = new window.FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        var base64data = reader.result;
        state.gifSrc = base64data;
        state.gifProcessing = false;
      };
      // let url = URL.createObjectURL(blob)
      // console.log(url)
      // state.gifSrc = url
    });
    gif.render();
  },
  _drawPuyo: function _drawPuyo(ctx, x, y, kind) {
    switch (kind) {// TODO: 定義の集約
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.RED:
        ctx.drawImage(imgpr, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.BLUE:
        ctx.drawImage(imgpb, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.GREEN:
        ctx.drawImage(imgpg, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.YELLOW:
        ctx.drawImage(imgpy, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.PURPLE:
        ctx.drawImage(imgpp, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.OJAMA:
        ctx.drawImage(imgpo, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.IRON:
        ctx.drawImage(imgpi, x, y);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.WALL:
        ctx.drawImage(imgpw, x, y);
        break;
    }
  },
  openGifView: function openGifView() {
    state.gifView = true;
  },
  closeGifView: function closeGifView() {
    state.gifView = false;
  },
  openChartView: function openChartView() {
    state.chartView = true;
  },
  closeChartView: function closeChartView() {
    state.chartView = false;
  },
  openTweetView: function openTweetView() {
    state.tweetText = state.chain + '連鎖' + state.score + '点（' + (state.turn + 1) + '手）\n';
    state.tweetText += '#puyosim\n';
    state.tweetText += 'https://sim.refpuyo.net/#' + state.hashStr;
    state.tweetView = true;
    if (state.tweetChecked) this.createGif();
  },
  closeTweetView: function closeTweetView() {
    state.tweetView = false;
  },
  debug: function debug() {
    game.setDown();
    updateField();
  },
  login: function login() {
    fb.login();
  },
  logout: function logout() {
    fb.logout();
  },
  tweet: function tweet() {
    if (state.gifProcessing === true) return;
    state.statusStr = 'ツイート処理中...';
    if (state.tweetChecked === true) {
      var toks = state.gifSrc.split(',');
      fb.tweet(state.tweetText, toks[1], function (isSuccess) {
        if (isSuccess) {
          state.statusStr = '投稿完了！';
        } else {
          state.statusStr = '投稿失敗...';
        }
        setTimeout(function () {
          state.statusStr = '';
        }, 1000);
      });
    } else {
      fb.tweet(state.tweetText, null, function (isSuccess) {
        if (isSuccess) {
          state.statusStr = '投稿完了！';
        } else {
          state.statusStr = '投稿失敗...';
        }
        setTimeout(function () {
          state.statusStr = '';
        }, 1000);
      });
    }
    this.closeHamburger();
  },
  openConfigView: function openConfigView() {
    state.configView = true;
  },
  closeConfigView: function closeConfigView() {
    state.configView = false;
    game.setNextMode(state.revision);
  },
  pushEditIcon: function pushEditIcon() {
    if (state.editView) {
      this.closeEditView();
    } else {
      this.openEditView();
    }
  },
  openEditView: function openEditView() {
    state.editView = true;
  },
  closeEditView: function closeEditView() {
    state.editView = false;
    game.saveField();
    updateField();
    updateInfo();
  },
  fieldClick: function fieldClick(x, y) {
    if (!state.editView) return;
    game.editField(x, y, state.editKind);
    updateField();
    updateInfo();
  },
  setEditKind: function setEditKind(kind) {
    state.editKind = kind;
  },
  editNextAxis: function editNextAxis(turn) {
    if (!state.editView) return;
    if (state.editKind === __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.PEKE) return;
    if (state.editKind === __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.WALL) return;
    game.editNext(turn, state.editKind, true);
    updateNext();
  },
  editNextSub: function editNextSub(turn) {
    if (!state.editView) return;
    if (state.editKind === __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.PEKE) return;
    if (state.editKind === __WEBPACK_IMPORTED_MODULE_0__libs_puyo_Puyo__["a" /* default */].Kind.WALL) return;
    game.editNext(turn, state.editKind, false);
    updateNext();
  },
  toggleLoginView: function toggleLoginView() {
    state.loginView = !state.loginView;
  },
  updateHash: function updateHash() {
    updateInfo();
  }
});

var imgback = new Image();
imgback.src = __webpack_require__("FMDN");
var imgpr = new Image();
imgpr.src = __webpack_require__("Bcqc");
var imgpg = new Image();
imgpg.src = __webpack_require__("FLKx");
var imgpb = new Image();
imgpb.src = __webpack_require__("jzv+");
var imgpy = new Image();
imgpy.src = __webpack_require__("VrRu");
var imgpp = new Image();
imgpp.src = __webpack_require__("8h30");
var imgpo = new Image();
imgpo.src = __webpack_require__("+gtd");
var imgpi = new Image();
imgpi.src = __webpack_require__("d7Vi");
var imgpw = new Image();
imgpw.src = __webpack_require__("IPdy");

/***/ }),

/***/ "jzv+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAwKisvkjQAAANBJREFUWMPtl0sOwjAMRGOLVXsADsGWE+Te9AKw5ShhO6wsWSifphAnEvG67byM3WhMAFxNrbRlXwjwVPO9U63o63rZ/eweGCo5sNKGkmiqlsezCJEEkJMcFdcQOTeiAN+cutYNthAXJ2MDzBbiOQh2nYutTp9ygQCYievC/UxdWyAudJ8BWtzN3H59N4zzF0yACfC/AAGeJDRY3wEBnmYLWPKaZRt0PGMdoS0gPrPhWDPQ2oVYMubYatUCIhXLx1xMhljNjjqi2/eT5bT1ev4GwRSZUy1rzJoAAAAASUVORK5CYII="

/***/ }),

/***/ "qtin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var table = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_';

/* harmony default export */ __webpack_exports__["a"] = ({
  base64ctoNum: function base64ctoNum(c) {
    for (var i = 0; i < table.length; i++) {
      if (c === table[i]) return i;
    }
    return 0;
  },
  base64stoNum: function base64stoNum(str) {
    var r = 0;
    var base = 1;
    for (var i = 0; i < str.length; i++) {
      var n = this.base64ctoNum(str[i]);
      r += n * base;
      base *= 64;
    }
    return r;
  },
  numToBase64c: function numToBase64c(n) {
    if (n > 63 || n < 0) return '?';
    return table[n];
  },
  numToBase64s: function numToBase64s(n) {
    if (n < 0) return '?';
    var s = '';
    for (var i = 0; i < 10; i++) {
      var d = n % 64;
      s += table[d];
      n = Math.floor(n / 64);
      if (n === 0) break;
    }
    return s;
  }
});

/***/ }),

/***/ "rVtZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Puyo__ = __webpack_require__("5oUX");


/* harmony default export */ __webpack_exports__["a"] = ({
  subPos: function subPos(axisPos, axisDir) {
    switch (axisDir) {
      case 0:
        return new __WEBPACK_IMPORTED_MODULE_0__Puyo__["a" /* default */].Pos(axisPos.x, axisPos.y + 1);
      case 1:
        return new __WEBPACK_IMPORTED_MODULE_0__Puyo__["a" /* default */].Pos(axisPos.x + 1, axisPos.y);
      case 2:
        return new __WEBPACK_IMPORTED_MODULE_0__Puyo__["a" /* default */].Pos(axisPos.x, axisPos.y - 1);
      case 3:
        return new __WEBPACK_IMPORTED_MODULE_0__Puyo__["a" /* default */].Pos(axisPos.x - 1, axisPos.y);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Puyo__["a" /* default */].Pos(); // error
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_Store__ = __webpack_require__("fBFr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_libs_puyo_Util__ = __webpack_require__("rVtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__ = __webpack_require__("5oUX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// let isPC = navigator.userAgent.indexOf('iPhone') === -1 && navigator.userAgent.indexOf('iPod') === -1 && navigator.userAgent.indexOf('Android') === -1
// console.log('isPC', isPC)

function isClickDownEvent(e) {
  var tapEventType = window.ontouchstart === null ? 'touchstart' : 'mousedown';
  return e.type === tapEventType;
}
// function isClickUpEvent (e) {
//   let tapEventType = window.ontouchstart === null ? 'touchend' : 'mouseup'
//   return e.type === tapEventType
// }

// TODO:mvvmに反してるので使わないように修正する
function setTouchStyle(e) {
  e.target.classList.add('b_touched');
}
function setUntouchStyle(e) {
  e.target.classList.remove('b_touched');
}

function puyoXpx(posX) {
  return 32 * (posX - 1);
}
function puyoYpx(posY) {
  return 32 * (13 - posY);
}

function keydown(e) {
  var code = e.keyCode;
  switch (code) {
    case 37:
      // ←キー
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveLeft();
      e.preventDefault();
      return;
    case 39:
      // →キー
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveRight();
      e.preventDefault();
      return;
    case 38:
      // ↑キー
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurnPrev();
      e.preventDefault();
      return;
    case 40:
      // ↓キー
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setDown();
      e.preventDefault();
      // goBottom()
      return;
    case 49:
      // 1
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.RED);
      return;
    case 50:
      // 2
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.GREEN);
      return;
    case 51:
      // 3
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.BLUE);
      return;
    case 52:
      // 4
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.YELLOW);
      return;
    case 53:
      // 5
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.PEKE);
      return;
    case 54:
      // 6
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.OJAMA);
      return;
    case 55:
      // 7
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.IRON);
      return;
    case 56:
      // 8
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.WALL);
      return;
    case 88:
      // x
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].turnRight();
      return;
    case 90:
      // z
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].turnLeft();
      return;
    case 67:
      // c
      return;
    case 68:
      // d
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].debug();
      return;
    case 69:
      // e
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].pushEditIcon();
      return;
    case 78:
      // n
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurnNext();
      return;
    case 82:
      // r
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurn(0);
      return;
    case 84:
      // t
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].init();
      return;
  }
}

// TODO: つらい vueらしい方法に変更
function goBottom() {
  setTimeout(function () {
    var el = document.getElementById('chart-area');
    el.scrollTop = el.scrollHeight;
  }, 20);
}
goBottom();

// let touchFlag = false
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    // PuyoField
  },
  mounted: function mounted() {
    this.$ga.page('/');
    document.title = __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].state.title;
    window.addEventListener('keydown', keydown, false);
    window.addEventListener('touchend', function (event) {
      if (event.target.type === 'checkbox') return;
      if (event.target.type === 'textarea') return;
      // console.log(event)
      event.preventDefault();
      // if (touchFlag) {
      //   event.preventDefault()
      // } else {
      //   touchFlag = true
      //   setTimeout(() => {
      //     touchFlag = false
      //   }, 5000)
      // }
      // event.stopPropagation()
      // if (touchFlag) {
      //   event.stopPropagation()
      // } else {
      //   touchFlag = true
      //   setTimeout(() => {
      //     touchFlag = false
      //   }, 300)
      // }
    }, false);
  },
  data: function data() {
    return {
      state: __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].state
    };
  },
  computed: {
    opsAxisSrc: function opsAxisSrc() {
      var pp = this.state.nextPuyoPairs[this.state.turn];
      return this.puyoSrc({ kind: pp.axis });
    },
    opsSubSrc: function opsSubSrc() {
      var pp = this.state.nextPuyoPairs[this.state.turn];
      return this.puyoSrc({ kind: pp.sub });
    },
    opsAxisStyle: function opsAxisStyle() {
      var opsX = this.state.ops.pos.x;
      var opsY = this.state.ops.pos.y;
      var vi = this.state.ops.available ? 'visible' : 'hidden';
      return 'left:' + puyoXpx(opsX) + 'px; top:' + puyoYpx(opsY) + 'px; visibility:' + vi;
    },
    opsSubStyle: function opsSubStyle() {
      var subPos = __WEBPACK_IMPORTED_MODULE_1__store_libs_puyo_Util__["a" /* default */].subPos(this.state.ops.pos, this.state.ops.dir);
      var vi = this.state.ops.available ? 'visible' : 'hidden';
      return 'left:' + puyoXpx(subPos.x) + 'px; top:' + puyoYpx(subPos.y) + 'px; visibility:' + vi;
    },
    nextPuyos: function nextPuyos() {
      var objs = [];
      for (var i = 0; i < this.state.nextDisplay.length; i++) {
        var nextLen = this.state.nextPuyoPairs.length;
        var nextPos = (this.state.turn + i + 1) % nextLen;
        var puyoPair = this.state.nextPuyoPairs[nextPos];
        var axisKind = puyoPair.axis;
        var subKind = puyoPair.sub;
        if (!this.state.nextDisplay[i].axis) axisKind = __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.WALL;
        if (!this.state.nextDisplay[i].sub) subKind = __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.WALL;
        objs.push({
          kind: subKind,
          x: 32 * i,
          y: 0
        });
        objs.push({
          kind: axisKind,
          x: 32 * i,
          y: 32
        });
      }
      return objs;
    },
    editPuyos: function editPuyos() {
      var kinds0 = [__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.RED, __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.GREEN, __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.BLUE, __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.YELLOW];
      var kinds1 = [__WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.PEKE, __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.OJAMA, __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.IRON, __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.WALL];
      var objs = [];
      for (var i = 0; i < this.state.nextDisplay.length; i++) {
        objs.push({
          kind: kinds0[i],
          x: 32 * i,
          y: 0
        });
        objs.push({
          kind: kinds1[i],
          x: 32 * i,
          y: 32
        });
      }
      return objs;
    },
    chartURL: function chartURL() {
      return 'https://sim.refpuyo.net/#' + this.state.hashStr;
    },
    puyoFieldTouchObjs: function puyoFieldTouchObjs() {
      var a = [];
      for (var x = 1; x <= 6; x++) {
        for (var y = 1; y <= 13; y++) {
          a.push({
            x: x,
            y: y
          });
        }
      }
      return a;
    },
    nazoStatusStr: function nazoStatusStr() {
      if (this.state.nazoClear) return 'クリア！';
      var prefix = '[' + this.state.nazoTurn + '手] ';
      switch (this.state.nazoMode) {
        case '未設定':
          return '';
        case '全消し':
          return prefix + '全消しすべし';
        case '連鎖':
          return prefix + this.state.nazoChain + '連鎖すべし';
        case '同時消し':
          return prefix + this.state.nazoConcurrent + '個同時に消すべし';
        case '個数':
          return prefix + this.state.nazoCount + '個消すべし';
      }
      return '';
    }
  },
  watch: {
    state: {
      handler: function handler(obj) {
        // console.log('watch: state changed.')
        document.title = obj.title;
      },
      deep: true
    },
    'state.turn': function stateTurn(turn) {
      var turnTopMin = 32 * turn;
      var turnTopMax = 32 * (turn + 1);
      var el = document.getElementById('chart-area');
      var elTopMin = el.scrollTop;
      var elTopMax = el.scrollTop + 32 * 8;
      if (elTopMin > turnTopMin) {
        el.scrollTop = turnTopMin;
      }
      setTimeout(function () {
        if (turnTopMax > elTopMax) {
          el.scrollTop = turnTopMax - 32 * 8;
        }
      }, 20); // この時点ではまだ生成されてないから苦肉の策
    },
    'state.tweetChecked': function stateTweetChecked(checked) {
      if (checked) {
        __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].createGif();
      }
    },
    'state.nazoMode': function stateNazoMode() {
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].updateHash();
    },
    'state.nazoChain': function stateNazoChain() {
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].updateHash();
    },
    'state.nazoTurn': function stateNazoTurn() {
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].updateHash();
    },
    'state.nazoCount': function stateNazoCount() {
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].updateHash();
    },
    'state.nazoConcurrent': function stateNazoConcurrent() {
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].updateHash();
    },
    'state.nazoClear': function stateNazoClear() {
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].updateHash();
    }
  },
  methods: {
    b_left: function b_left(e) {
      if (!isClickDownEvent(e)) return;
      setTouchStyle(e);
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveLeft();
      // e.stopPropagation()
    },
    b_right: function b_right(e) {
      if (!isClickDownEvent(e)) return;
      setTouchStyle(e);
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveRight();
      // e.stopPropagation()
    },
    b_down: function b_down(e) {
      if (!isClickDownEvent(e)) return;
      setTouchStyle(e);
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setDown();
      // e.stopPropagation()
    },
    b_turnLeft: function b_turnLeft(e) {
      if (!isClickDownEvent(e)) return;
      setTouchStyle(e);
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].turnLeft();
      // e.stopPropagation()
    },
    b_turnRight: function b_turnRight(e) {
      if (!isClickDownEvent(e)) return;
      setTouchStyle(e);
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].turnRight();
      // e.stopPropagation()
    },
    b_untouch: function b_untouch(e) {
      setUntouchStyle(e);
    },
    b_chart: function b_chart(e, i) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurn(i);
    },
    b_prev: function b_prev(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurnPrev();
      // e.stopPropagation()
    },
    b_next: function b_next(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurnNext();
      // e.stopPropagation()
    },
    b_debug: function b_debug(e) {
      if (!isClickDownEvent(e)) return;
    },
    bTweet: function bTweet(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].tweet();
      // e.stopPropagation()
    },
    puyoSrc: function puyoSrc(obj) {
      if (obj.state === 'extinction') return __webpack_require__("xQou");
      switch (obj.kind) {
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.RED:
          return __webpack_require__("Bcqc");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.GREEN:
          return __webpack_require__("FLKx");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.BLUE:
          return __webpack_require__("jzv+");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.YELLOW:
          return __webpack_require__("VrRu");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.OJAMA:
          return __webpack_require__("+gtd");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.IRON:
          return __webpack_require__("d7Vi");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.WALL:
          return __webpack_require__("IPdy");
        case __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.PEKE:
          return __webpack_require__("K7Qp");
      }
      return __webpack_require__("xQou");
    },
    puyoHistoryAxisSrc: function puyoHistoryAxisSrc(obj, index) {
      var pp = this.state.nextPuyoPairs[index];
      return this.puyoSrc({ kind: pp.axis });
    },
    puyoHistorySubSrc: function puyoHistorySubSrc(obj, index) {
      var pp = this.state.nextPuyoPairs[index];
      return this.puyoSrc({ kind: pp.sub });
    },
    puyoStyle: function puyoStyle(obj) {
      var vi = obj.kind === __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.BRANK && obj.state !== 'extinction' ? 'hidden' : 'visible';
      return 'left:' + puyoXpx(obj.pos.x) + 'px; top:' + puyoYpx(obj.pos.y) + 'px; visibility:' + vi;
    },
    nextPuyoStyle: function nextPuyoStyle(obj) {
      var vi = obj.kind === __WEBPACK_IMPORTED_MODULE_2__store_libs_puyo_Puyo__["a" /* default */].Kind.BRANK && obj.state !== 'extinction' ? 'hidden' : 'visible';
      return 'left:' + obj.x + 'px; top:' + obj.y + 'px; visibility:' + vi;
    },
    toggleNext: function toggleNext(e, index) {
      // TODO: index を使うのは妥協なので、良い方法を考える
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].toggleNextDisplay(Math.floor(index / 2), index % 2 === 1);
    },
    hamburger: function hamburger(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].toggleHamburger();
    },
    tInit: function tInit(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].init();
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].toggleHamburger();
    },
    tReset: function tReset(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].moveTurn(0);
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].toggleHamburger();
    },
    tCreateGif: function tCreateGif(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].openGifView();
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].createGif();
    },
    tTweet: function tTweet(e) {
      if (!isClickDownEvent(e)) return;
      // e.preventDefault()
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].openTweetView();
    },
    tConfig: function tConfig(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].openConfigView();
    },
    login: function login(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].login();
    },
    logout: function logout(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].logout();
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].toggleLoginView();
    },
    clickTweetCheck: function clickTweetCheck(e) {
      if (!isClickDownEvent(e)) return;
      e.toElement.checked = !e.toElement.checked;
    },
    pushEditIcon: function pushEditIcon(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].pushEditIcon();
    },
    puyoFieldTouch: function puyoFieldTouch(e, obj) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].fieldClick(obj.x, obj.y);
    },
    puyoFieldTouchStyle: function puyoFieldTouchStyle(obj) {
      var s = 'position: absolute;';
      s += ' top: ' + (13 - obj.y) * 32 + 'px;';
      s += ' left: ' + (obj.x - 1) * 32 + 'px;';
      s += ' width: 32px;';
      s += ' height: 32px;';
      return s;
    },
    editPuyoTouch: function editPuyoTouch(e, obj) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].setEditKind(obj.kind);
    },
    editPuyoTouchStyle: function editPuyoTouchStyle(obj) {
      var s = 'position: absolute;';
      s += ' top: ' + obj.y + 'px;';
      s += ' left: ' + obj.x + 'px;';
      s += ' width: 28px;';
      s += ' height: 28px;';
      if (obj.kind === this.state.editKind) s += ' border: solid 2px #ff0000;';
      return s;
    },
    editChartLeft: function editChartLeft(e, index) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].editNextAxis(index);
    },
    editChartRight: function editChartRight(e, index) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].editNextSub(index);
    },
    loginClick: function loginClick(e) {
      if (!isClickDownEvent(e)) return;
      __WEBPACK_IMPORTED_MODULE_0__store_Store__["a" /* default */].toggleLoginView();
    }
  }
});

/***/ }),

/***/ "xQou":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHABohOu+oGgAAANVJREFUWMPtV8sOwzAIA2v//8veqRLamtU8qkhTc8kFsEnAJE7SqsvdSdKtsWCbFzrZx33bCYxfgZrRAazar+xeZ4EP41/ZZYFXsVBhHQN2SfqqDaNz5Z5VfyjFla30DHmoFV4pNuXkcFebqX7ekeKtSvh/BKK2d/V9VZxn88PNjNMFmBEkkPQIpChctSM+cUj60wUPAWRbaNJWIlDVBNVPfpCobZmdoJgEr5BAB1x5sl0qYXWmK/8C5eS+lDDz3VJez1dxy1KcAb9ViLZ9zaam5nYpfgMbSrQzTxKk8QAAAABJRU5ErkJggg=="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0f13ca534e0168673787.js